import { useEffect, useState } from "react";
import ImageCrop from "../../pages/Map/ImageCrop";

const CroppedImageWithFallback = ({ imageCropItem, component = false, projectType }) => {
  const [isCroppedImageValid, setIsCroppedImageValid] = useState(true);

  useEffect(() => {
    if (!imageCropItem.croppedPath) {
      setIsCroppedImageValid(false);
      return;
    }

    const img = new Image();
    img.src = imageCropItem.croppedPath;
    img.onload = () => setIsCroppedImageValid(true);
    img.onerror = () => setIsCroppedImageValid(false);
  }, [imageCropItem.croppedPath]);

  const isAerial = projectType === "AERIAL";

  const containerStyle = component
    ? { width: "100px", height: "100px", padding: "0" }
    : isAerial
      ? { width: "180px", height: "180px", padding: "0" }
      : { width: "66px", height: "100%", padding: "0" };

  const imageDimensions = component
    ? { height: 100, width: 100 }
    : isAerial
      ? { height: 180, width: 180 }
      : { height: 654, width: 66 };

  return (
    <div style={containerStyle}>
      {isCroppedImageValid ? (
        <img
          src={imageCropItem.croppedPath}
          alt="Cropped"
          {...imageDimensions}
          style={{ objectFit: "cover" }}
        />
      ) : (
        <ImageCrop
          {...imageDimensions}
          imageSrc={imageCropItem.image.path_low}
          detectionData={imageCropItem}
          projectType={projectType}
        />
      )}
    </div>
  );
};

export default CroppedImageWithFallback;

